import type { RouteRecordRaw } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import PageBuildingProfilUtilisation from "./pages/PageBuildingProfilUtilisation.vue"

export const buildingShellChildren = [
    {
        path: "energy-manager/profil-utilisation",
        name: "PageBuildingProfilUtilisation",
        component: PageBuildingProfilUtilisation,
        beforeEnter: async (to, _from, next) => {
            const authStore = useAuthStore()
            if (authStore.isLogged && !authStore.userId) {
                await authStore.fetchUser()
            }
            if (authStore.hasOfferEnergyManager) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
] as RouteRecordRaw[]
